<script setup lang="ts">
  import { computed } from 'vue';
  import type { PropType } from 'vue';
  import type { ServiceUseCaseItem } from '~/models/service';

  const props = defineProps({
    useCaseItem: {
      type: Object as PropType<ServiceUseCaseItem>,
      required: true
    },
    useCaseButtonText: {
      type: String,
      required: true
    },
    localePath: {
      type: Function as PropType<(to: { name: string; params: { slug: string } }) => string>,
      required: true
    }
  });

  const bgImageStyle = computed(() => {
    if (!props.useCaseItem.cover || !props.useCaseItem.cover.src) {
      return {};
    }

    return {
      '--bg-image': `url(${props.useCaseItem.cover.src})`
    };
  });
</script>

<template>
  <div
    class="service-card-base service-card"
    :style="bgImageStyle">
    <div class="service-card__bg"><div /></div>
    <div class="service-card__icon">
      <nuxt-icon
        v-if="useCaseItem.icon"
        :name="`telekom:${useCaseItem.icon}`" />
    </div>
    <h2 class="service-card__title">{{ useCaseItem.title }}</h2>
    <p class="service-card__description">{{ useCaseItem.description }}</p>
    <div class="service-card__footer">
      <NuxtLink
        class="service-card__link"
        :to="localePath({ name: 'use-cases-slug', params: { slug: useCaseItem.slug } })">
        {{ useCaseButtonText }}
      </NuxtLink>
    </div>
  </div>
</template>
